<template>
    <v-container>
        <v-skeleton-loader
            v-if="!videos"
            type="list-item-avatar-two-line@3"
        ></v-skeleton-loader>

        <div v-else-if="videos.length == 0">Belum ada video</div>

        <v-list
            v-else
            class="elevation-1"
        >
            <v-list-item
                v-for="video in videos"
                :key="video.hash"
                :to="{ name: 'kelon.play', params: { hash: video.hash } }"
            >
                <v-list-item-avatar>
                    <v-icon>mdi-video</v-icon>
                </v-list-item-avatar>

                <v-list-item-content>
                    <v-list-item-title>{{ video.title }}</v-list-item-title>
                    <v-list-item-subtitle>
                        {{
                            video.discussions
                                ? video.discussions.join(', ')
                                : null
                        }}
                    </v-list-item-subtitle>
                </v-list-item-content>

                <v-list-item-action>
                    <v-icon>mdi-chevron-right</v-icon>
                </v-list-item-action>
            </v-list-item>
        </v-list>
    </v-container>
</template>

<script>
import moment from '@/plugins/moment'

export default {
    data: () => ({
        videos: null,
    }),

    async created() {
        const response = await this.$apiv2.get('user/period/kelon/video')
        this.videos = response.data.videos.map((video) => ({
            ...video,
            title: moment(video.createdAt).format('D MMMM YYYY'),
            discussions: video.discussions.map((e) => e.title),
        }))
    },
}
</script>
